/**
 * Created by tudou on 2020/4/10 20:19.
 */
export default {
  // 全局公用
  app: {
    title: 'Kart',
    todo: '消息中心',
  },
  common: {
    queryBtn: '查询',
    resetBtn: '重置',
    loading: '拼命处理中...',
    addBtn: '添加',
    editBtn: '编辑',
    viewBtn: '查看',
    downloadBtn: '下载',
    printBtn: '打印',
    deleteBtn: '删除',
    logBtn: '操作日志',
    saveBtn: '保存',
    submitBtn: '提交',
    barUnfold: '展开',
    barFold: '收起',
    pageTotal: '共',
    pageItem: '条',
    deleteConfim: '此操作将永久删除该数据，请确定是否要删除？'
  }
};
